var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"pieChart",staticClass:"chart-container",staticStyle:{"height":"250px","margin-top":"15px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }